export const auth = {
  signIn: 'Sign in',
  signOut: 'Sign out',
  twoFactor: 'Two-factor authentication',
  forgotPassword: 'Forgot password',
};
